import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["selectAll", "item"]

  toggleAll() {
    const checked = this.selectAllTarget.checked
    this.itemTargets.forEach(item => {
      item.checked = checked
      item.closest("tr").style.fontWeight = checked ? "bold" : "normal"
    })
  }

  toggleItem(event) {
    const row = event.currentTarget.closest("tr")
    row.style.fontWeight = event.currentTarget.checked ? "bold" : "normal"
    this.selectAllTarget.checked = this.itemTargets.every(item => item.checked)
  }
}
